import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../lib/content";
import ServiceCard from "./ServiceCard";

export default function ServicesPreview() {
  return (
    <section data-testid="services-preview" className="relative py-24 md:py-32 lg:py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 text-[#B8965A]">
              <span className="block w-8 h-px bg-[#C9A86A]" />
              <span className="text-[11px] uppercase tracking-[0.3em]">Our Craft</span>
            </div>
            <h2 className="mt-6 font-display-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter text-[#0A0A0A] max-w-3xl">
              A complete stone <br className="hidden md:block" />
              restoration <span className="font-serif-italic font-light text-[#B8965A]">studio.</span>
            </h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-[#525252] max-w-md text-[15px] leading-relaxed"
          >
            Eight specialised disciplines, one obsessive standard of finish.
            From single benchtops to lobby-wide programs.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <Link
            to="/services"
            data-testid="services-preview-cta"
            className="group inline-flex items-center gap-3 px-8 py-4 border border-[#0A0A0A]/25 text-[#0A0A0A] uppercase tracking-[0.22em] text-[11px] hover:bg-[#0A0A0A] hover:text-white transition-colors"
          >
            View all services
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
